<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMEP"><span class="ePub-I">Yesterday I was clever, so I wanted to change the world.</span></p>
<p class="FMEP"><span class="ePub-I">Today I am wise, so I am changing myself.</span></p>
<p class="FMEPC"><span class="ePub-SC">—</span>R<span class="ePub-SC">UMI</span></p>
<p class="FMEP"><span class="ePub-I">Monday, Monday. Can’t trust that day.</span></p>
<p class="FMEPC"><span class="ePub-SC">—</span>T<span class="ePub-SC">HE </span>M<span class="ePub-SC">AMAS</span> &amp; <span class="ePub-SC">THE </span>P<span class="ePub-SC">APAS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?68b6b5c0